import React from 'react';
import { useQueryParam } from 'use-query-params';
import { isProduction } from '@fourthwall/utils';
import { routing } from '@utils/routing';
import { thumbnails } from '../../assets/thumbnails';
import { AppsIntegrationUnified } from '../AppsIntegrationUnified';
import { AppsKitSettings } from './AppsKitSettings';
export const AppsKit = () => {
    const [kitReturn] = useQueryParam('kitReturn');
    if (typeof kitReturn === 'string' && kitReturn.includes('kit.com')) {
        window.location.assign(kitReturn);
    }
    const kitRedir = isProduction()
        ? 'https://app.kit.com/apps/567/install'
        : 'https://app.kit.com/apps/569/install';
    const returnUrl = `${window.location.toString()}?kitReturn=${kitRedir}`;
    return (React.createElement(AppsIntegrationUnified, { appId: "kit", name: "Kit", logoSrc: thumbnails.kitThumbnail, connectDescription: "Connect to your Kit account.", longDescription: "Use Kit to sync supporter emails and send custom emails.", helpCenterUrl: routing.external.helpCenter.kit, returnUrl: returnUrl },
        React.createElement(AppsKitSettings, null)));
};
